<template>
  <section class="reviews">
    <div class="reviews__stats">
      <div class="reviews__stats__content">
        <h2 class="reviews__stats__title">Nos avalan</h2>
        <p class="reviews__stats__info"><span class="reviews__stats__info__highlight">+5000</span>Familias felices</p>
        <p class="reviews__stats__info"><span class="reviews__stats__info__highlight">+1000M €</span>Valor total de hipotecas</p>
        <p class="reviews__stats__info"><span class="reviews__stats__info__highlight">2,54%</span>TIN promedio</p>
      </div>
    </div>

    <div class="reviews__comments">
      <div class="reviews__comments__content">
        <div class="reviews__comments__wrapper">
          <Viewport>
            <template #xs>
              <div class="reviews__comments__wrapper__horizontal">
                <Review v-for="(review, i) in reviews" :key="i" :slot="i" :review="review" />
              </div>
            </template>

            <template #lg>
              <Carousel
                v-model="slide"
                orientation="horizontal"
                transition-easing="cubic-bezier(1, 0.06, 0, 0.93)"
                class="reviews__comments__list"
                :controls="false"
                :arrows="false"
                :transition-duration="350"
              >
                <Review v-for="(review, i) in reviews" :slot="i" :key="i" :review="review" />
              </Carousel>
            </template>
          </Viewport>
        </div>

        <div class="reviews__comments__footer">
          <div class="reviews__comments__footer__content">
            <p class="reviews__comments__footer__global">4.9</p>
            <div class="reviews__comments__footer__wrapper">
              <div class="reviews__comments__footer__rate">
                <i class="reviews__comments__footer__rate__icon"></i>
                <i class="reviews__comments__footer__rate__icon"></i>
                <i class="reviews__comments__footer__rate__icon"></i>
                <i class="reviews__comments__footer__rate__icon"></i>
                <i class="reviews__comments__footer__rate__icon"></i>
              </div>
              <img src="img/web/icons/Google.svg" alt="Logo Google" />
            </div>
          </div>
          <div class="reviews__comments__footer__controls">
            <CarouselControls
              inline
              v-model="slide"
              :count="reviews.length"
              :dot-style="{
                border: '1px solid #1E2F4B',
                backgroundColor: 'transparent',
                boxShadow: 'none',
              }"
              :dot-selected-style="{
                backgroundColor: '#1E2F4B',
                boxShadow: 'none',
                transform: 'scale(1)',
              }"
            />
            <a class="reviews__comments__footer__external-link" :href="reviewsUrl" target="_blank">
              Ver todas las valoraciones
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { isMobile } from '@/lego/utils/platform/device';
import Carousel from '@/lego/components/carousels/Carousel.vue';
import CarouselControls from '@/lego/components/carousels/CarouselControls.vue';
import { ref } from '@vue/composition-api';
import Viewport from '@/lego/components/tools/Viewport.vue';
import Review from '@/lego/partials/home/reviews/Review.vue';

export default {
  components: { Carousel, CarouselControls, Viewport, Review },

  setup() {
    return {
      slide: ref(0),
      reviews: [
        {
          name: 'Elvira Pérez',
          image: 'elvira',
          numberOfReviews: '2 valoraciones',
          whenLastReview: 'Hace 2 días',
          review:
            'He tenido muy buena experiencia con Trioteca, gracias a Ronald y especialmente a Cynthia conseguimos que los trámites se resolvieran en un plazo razonable de tiempo. Les estoy muy agradecidos! Totalmente recomendable!',
          stars: 5,
        },
        {
          name: 'Jeremy Verao',
          image: 'jeremy',
          numberOfReviews: '1 valoración',
          whenLastReview: 'Hace 2 días',
          review:
            'TRIOTECA es una estructura muy competente con respecto al proceso de cambio de hipoteca. Laura me ha ayudado mucho y me ha facilitado las tareas. Muy recomendable !',
          stars: 5,
        },
        {
          name: 'Cristina Martín',
          image: 'cristina',
          numberOfReviews: '80 valoraciones',
          whenLastReview: 'Hace 3 días',
          review:
            'Nos ayudaron a conseguir una oferta hipotecaria muy buena y nos acompañaron durante todo el proceso, resolviendo todas nuestras dudas. ¡Gracias!',
          stars: 5,
        },
        {
          name: 'Carles',
          image: 'carles',
          numberOfReviews: '1 valoración',
          whenLastReview: 'Hace 4 días',
          review: 'Muy atentos en todo momento. He tenido la tranquilidad de disponer de su ayuda.',
          stars: 5,
        },
      ],
      reviewsUrl: isMobile()
        ? 'https://www.google.com/search?q=trioteca+reviews&oq=trioteca+reviews#lkt=LocalPoiReviews&trex=m_t:lcl_akp,rc_f:nav,rc_ludocids:15823220965021819260,rc_q:TRIOTECA,ru_q:TRIOTECA,trex_id:Rpvenc'
        : 'https://www.google.com/search?q=trioteca+reviews&oq=trioteca+reviews#lrd=0x12a4970918dcf147:0xdb975fa1f6a3a17c,1',
    };
  },
};
</script>

<style scoped lang="postcss">
.reviews {
  @apply flex flex-col lg:flex-row;

  &__stats {
    @apply lg:w-1/2 bg-brand-primary-medium;

    &__content {
      @apply xl:col-5-12 lg:mr-[25%] lg:float-right xl:mr-micro pt-xl pb-md lg:py-xxxl text-center lg:text-left;
    }

    &__title {
      @apply style-subtitle-bold lg:style-title-bold text-neutral-ultradark;
    }

    &__info {
      @apply text-brand-secondary style-body-sm-bold mt-sm;

      &__highlight {
        @apply block text-neutral-white style-display-bold;
      }
    }
  }

  &__comments {
    @apply lg:w-1/2 lg:pr-xxs bg-neutral-lightest;

    &__content {
      @apply pt-xxs pb-xs xl:col-5-12 lg:ml-xxs xl:ml-xxl lg:flex lg:flex-col lg:justify-center lg:h-full;
    }

    &__wrapper {
      @apply relative overflow-x-auto lg:max-w-full lg:overflow-x-clip;

      &__horizontal {
        @apply flex flex-row px-xxs;
      }
    }

    &__list {
      @apply w-full h-[13rem] left-0 inline-flex flex-row px-xxxs sm:px-xxs lg:px-0;
    }

    &__footer {
      @apply flex flex-col items-center lg:items-end mt-xs lg:mt-sm lg:ml-xl;

      &__content {
        @apply flex items-center justify-center lg:justify-end text-brand-secondary;
      }

      &__controls {
        @apply w-full flex flex-row justify-center lg:justify-between items-center mt-xxs;

        .carousel-controls {
          @apply hidden lg:flex;
        }
      }

      &__global {
        @apply font-bold font-highlight text-nano text-brand-secondary-medium;
      }

      &__wrapper {
        @apply flex flex-col items-center ml-nano;

        img {
          @apply mt-quark;
        }
      }

      &__rate {
        @apply inline-flex relative w-[4rem] justify-around;

        &__icon {
          @apply icon icon-micro icon-star-black;
        }
      }

      &__external-link {
        @apply flex style-overline-underline text-neutral-medium;
      }
    }
  }
}
</style>
